import React from 'react';
import {Image, Text, TouchableOpacity, View} from 'react-native';
import {styles} from './styles';
import {Colors} from '../../../../../constants/Colors';

interface IProduct {
  uri: string;
  title: string;
  onPress: () => void;
  isFeatured?: boolean;
  isOffers?: boolean;
}

const Product = ({uri, title, onPress, isFeatured = false, isOffers = false}: IProduct) => {
  if (isOffers) {
    return (
      <TouchableOpacity style={[styles.button, {borderWidth: 0, borderColor: 'transparent'}]} onPress={onPress}>
        <View
          style={{
            height: 100,
            width: 100,
            borderRadius: 50,
            backgroundColor: '#FF8C00',
            justifyContent: 'center',
            alignItems: 'center',
          }}>
          <Text style={{fontSize: 32, textAlign: 'center'}}>🏷️</Text>
          <Text
            style={{
              fontSize: 12,
              fontWeight: 'bold',
              color: 'white',
              marginTop: 4,
              textAlign: 'center',
            }}>
            Ofertas
          </Text>
        </View>
        <Text style={[styles.title, {fontWeight: 'bold', color: '#FF8C00'}]}>
          {title}
        </Text>
      </TouchableOpacity>
    );
  }

  if (isFeatured) {
    // Estilo especial para a bolinha "Imperdíveis"
    return (
      <TouchableOpacity style={[styles.button, {borderWidth: 0, borderColor: 'transparent'}]} onPress={onPress}>
        <View
          style={{
            height: 100,
            width: 100,
            borderRadius: 50,
            backgroundColor: Colors.RedPallete.red,
            justifyContent: 'center',
            alignItems: 'center',
            borderWidth: 3,
            borderColor: '#FFD700', // Dourado para destacar
          }}>
          <Text
            style={{
              fontSize: 32,
              textAlign: 'center',
            }}>
            🔥
          </Text>
          <Text
            style={{
              fontSize: 12,
              fontWeight: 'bold',
              color: 'white',
              marginTop: 4,
              textAlign: 'center',
            }}>
            Destaques
          </Text>
        </View>
        <Text style={[styles.title, {fontWeight: 'bold', color: Colors.RedPallete.red}]}>
          {title}
        </Text>
      </TouchableOpacity>
    );
  }

  return (
    <TouchableOpacity style={styles.button} onPress={onPress}>
      <Image
        source={{uri: uri}}
        style={{height: 100, width: 100, objectFit: 'contain'}}
      />
      <Text style={styles.title}>{title}</Text>
    </TouchableOpacity>
  );
};

export default Product;
